export default "__VITE_ASSET__A$6MU2EC__"